import { useTranslation } from 'react-i18next';
import { useLanguage } from '../hooks/useLanguage';

// IL SELETTORE DI LINGUA COMPATTO DELLA BARRA (2026-09-17).
//
// Prima erano pulsanti affiancati (EN IT ES FR DE): ogni lingua aggiunta
// allargava la barra di ~35px e dal francese in poi il bottone di accesso
// finiva fuori dallo schermo a 1280 (misurato: -29px con quattro lingue,
// -76 con cinque). Questo controllo e' largo uguale con due lingue o con
// sei: un'icona e la sigla di quella corrente.
//
// Sotto c'e' un <select> NATIVO, trasparente, che copre tutto il controllo:
// la tendina la disegna il sistema (su telefono e' la rotella/il foglio di
// iOS e Android, sul PC il menu del browser), non c'e' nessun pannello da
// posizionare, ritagliare o chiudere al clic fuori, e la tastiera e lo
// screen reader lo trovano da soli. Cio' che si VEDE da chiuso e' la sigla
// disegnata da noi, cosi' la larghezza non dipende dal nome della lingua.
//
// Usato solo da SiteNav (barra e pannello del telefono). Il vecchio
// LanguageSwitcher resta dov'era altrove (profilo, StackSocial, dock).
const NOMI = { en: 'English', it: 'Italiano', es: 'Español', fr: 'Français', de: 'Deutsch' };

export default function LanguageMenu({ className = '' }) {
  const { language, changeLanguage, supported } = useLanguage();
  const { t } = useTranslation('common');
  const sigla = String(language || 'en').slice(0, 2).toLowerCase();

  return (
    <span className={`cps-lingua ${className}`}>
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
           strokeWidth="1.8" strokeLinecap="round" aria-hidden="true" focusable="false">
        <circle cx="12" cy="12" r="9" />
        <path d="M3 12h18M12 3c2.8 3 2.8 15 0 18M12 3c-2.8 3-2.8 15 0 18" />
      </svg>
      <span className="cps-lingua-sigla" aria-hidden="true">{sigla.toUpperCase()}</span>
      <select
        value={supported.includes(sigla) ? sigla : 'en'}
        onChange={(e) => changeLanguage(e.target.value)}
        aria-label={t('language_label')}
      >
        {supported.map((l) => <option key={l} value={l}>{NOMI[l] || l.toUpperCase()}</option>)}
      </select>
    </span>
  );
}
